import { render, staticRenderFns } from "./addDizhiSG.vue?vue&type=template&id=5108bc74&scoped=true&"
import script from "./addDizhiSG.vue?vue&type=script&lang=js&"
export * from "./addDizhiSG.vue?vue&type=script&lang=js&"
import style0 from "./addDizhiSG.vue?vue&type=style&index=0&id=5108bc74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108bc74",
  null
  
)

export default component.exports